import * as React from 'react';

import { Paper, Typography, LinearProgress, Grid, Table, TableBody, TableRow, TableCell, TableHead, Button, Dialog, DialogTitle, DialogContent, DialogActions } from '@material-ui/core';
import { NumberPercent, NumberConvert } from '../../../../../services';

// tslint:disable-next-line:no-empty-interface
export interface IMarketShareBookstoreCategoryBisacShareAnalyticalProps {
    data: any;
    loading: boolean;
    type: string;
}

// tslint:disable-next-line:no-empty-interface
export interface IMarketShareBookstoreCategoryBisacShareAnalyticalState {
    data: any[];
    dialogOpen: boolean;
}

const dataFilled = (data: any) => {
    return data && data.marketCategoryBookstoreSalesByTheme && !!data.marketCategoryBookstoreSalesByTheme.length
}

export const ComparativeTable = ({data, isReducedList}: {data:any[], isReducedList: boolean}) => {

    data.sort( (obj1:any, obj2: any)=> {
        return obj2.valueMarket - obj1.valueMarket;
    });

    if(isReducedList && data.length > 6) {
        data = data.slice(0,6);
    }

    return (
        <Table>
            <TableHead>
                <TableRow>
                    <TableCell>Bisac</TableCell>
                    <TableCell>Mercado</TableCell>
                    <TableCell>Rede</TableCell>
                    <TableCell>Lojas</TableCell>
                </TableRow>
            </TableHead>
            <TableBody>
                { data && data.length > 0 && data.map( (row:any, index:number) =>
                    (
                        <TableRow key={index}>
                            <TableCell style={{paddingRight: 0, paddingLeft: 10}}> 
                                { row.desc } 
                            </TableCell>
                            <TableCell style={{paddingRight: 0}}>
                                <span >{row.valueMarket.toFixed(2).replace('.',',') + '%'}</span>
                            </TableCell>
                            <TableCell style={{paddingRight: 0}}>
                                <span >{row.valueGroup.toFixed(2).replace('.',',') + '%'}</span>
                            </TableCell>
                            <TableCell style={{paddingRight: 0}}>
                                <span >{row.valueStore.toFixed(2).replace('.',',') + '%'}</span>
                            </TableCell>
                        </TableRow>
                    )
                )}
            </TableBody>
        </Table>
    );
}

export class MarketShareBookstoreCategoryBisacShareAnalytical extends React.Component<IMarketShareBookstoreCategoryBisacShareAnalyticalProps, IMarketShareBookstoreCategoryBisacShareAnalyticalState> {

    constructor(props: IMarketShareBookstoreCategoryBisacShareAnalyticalProps) {
        super(props);
        this.state = {
            data: [],
            dialogOpen: false
        }
    }

    public UNSAFE_componentWillReceiveProps(nextProps:any) {
        if(nextProps && nextProps.data && nextProps.data.marketCategoryBookstoreSalesByTheme) {
            this.convertData(nextProps.data.marketCategoryBookstoreSalesByTheme, this.props.type).then((result:any[])=> {
                this.setState({data: result});
            });
        }
    }

    public render() {
        return (
            <Grid item={true} xs={6} md={6}>
                <Paper className="publisher-sale-block panel-block">
                    <Typography variant="headline" className="panel-title" component="title">
                        {this.props.type} Percentual de Vendas por Tema - 30 Dias
                    </Typography>
                    {
                        this.props.loading
                        ?
                        <LinearProgress />
                        :
                        (
                            dataFilled(this.props.data)
                            ?
                            (
                                <div>
                                    <ComparativeTable data={this.state.data} isReducedList={true} />
                                    <div className="filter-item">
                                        <Button onClick={this.handleDialogOpen} color="primary">
                                            Ver Mais
                                        </Button>
                                        <Dialog
                                            fullScreen={true}
                                            open={this.state.dialogOpen}
                                            onClose={this.handleDialogClose}
                                            aria-labelledby="economic-group-dialog-title"
                                            aria-describedby="alereconomic-group-dialog-description"
                                            className="filter-dialog">
                                            <DialogTitle className="filter-dialog-title" id="economic-group-dialog-title">
                                                {this.props.type+" Percentual de Vendas por Tema - 30 Dias"}
                                            </DialogTitle>
                                            <DialogContent className="filter-dialog-content">
                                                <Paper className="publisher-sale-block panel-block" >
                                                    {this.props.loading && <LinearProgress />}
                                                    <ComparativeTable data={ this.state.data } isReducedList={false} />
                                                </Paper>
                                            </DialogContent>
                                            <DialogActions className="filter-actions">
                                                <Button className="filter-dialog-close" onClick={this.handleDialogClose} >
                                                    Fechar
                                                </Button>
                                            </DialogActions>
                                        </Dialog>
                                    </div>
                                </div>
                            )
                            :
                            (<Typography variant="body2" className="comparative" component="p">
                                Não há informações de vendas
                            </Typography>)
                        )
                    }
                </Paper>
            </Grid>
        );
    }

    private async convertData(data: any[], type:string) {

        const mappedData: any[] = [];

        if(data) {
            let totalGroup : number = 0;
            let totalMarket : number = 0;
            let totalStory : number = 0;

            await data.forEach(e => {
                if(type === 'VOLUME') {
                    totalGroup  += e.groupSalesVolume  ? Number.parseFloat(e.groupSalesVolume.toString())  : 0;
                    totalMarket += e.marketSalesVolume ? Number.parseFloat(e.marketSalesVolume.toString()) : 0;
                    totalStory   += e.storeSalesVolume    ? Number.parseFloat(e.storeSalesVolume.toString())    : 0;
                } else {
                    totalGroup  += e.groupSalesBilling  ? Number.parseFloat(e.groupSalesBilling.toString())  : 0;
                    totalMarket += e.marketSalesBilling ? Number.parseFloat(e.marketSalesBilling.toString()) : 0;
                    totalStory   += e.storeSalesBilling    ? Number.parseFloat(e.storeSalesBilling.toString())    : 0;
                }
            });

            await data.forEach(e => {
                const item: any = {
                    desc: e.desc && e.desc.length > 30 ? e.desc.substr(0,30) : e.desc,

                    valueGroup: type === 'VOLUME' ? 
                        (NumberPercent(totalGroup,NumberConvert(e.groupSalesVolume))) :
                        (NumberPercent(totalGroup,NumberConvert(e.groupSalesBilling))),

                    valueMarket: type === 'VOLUME' ? 
                        (NumberPercent(totalMarket,NumberConvert(e.marketSalesVolume))) : 
                        (NumberPercent(totalMarket,NumberConvert(e.marketSalesBilling))),

                    valueStore: type === 'VOLUME' ? 
                        (NumberPercent(totalStory,NumberConvert(e.storeSalesVolume))) : 
                        (NumberPercent(totalStory,NumberConvert(e.storeSalesBilling)))
                };
                mappedData.push(item);
            });
        }

        return mappedData;
    }

    private handleDialogOpen = () => {
        this.setState({ dialogOpen: true });
    };

    private handleDialogClose = () => {
        this.setState({ dialogOpen: false });
    };
}



// WEBPACK FOOTER //
// ./src/component/market/bookstore/categoryShare/bisacShareAnalytical/MarketShareBookstoreCategoryBisacShareAnalytical.tsx